<template>
  <div class="function-information">
    <div v-if="!isLoading" class="function-information__wrapper">
      <performers-sidesheet ref="performersSidesheet" @goToNextPage="goToNextPagePerformers" @updateList="updateWorkersListWithFilters" @reset-workers="resetWorkers" :isLoading="isLoadingPerfomers" />

      <div class="row">
        <div class="col col-12 col-md-10 col-xl-10">
          <c-input
            v-model="form.name"
            :max-length="255"
            floating-label="Название"
            :clearable="true"
            :required-mark="true"
            :required="isSubmitted && nameError"
            :required-condition="isSubmitted && nameError"
          />
        </div>
      </div>

      <div class="row">
        <div class="col col-12 col-md-5 col-xl-5">
          <c-input
            v-model="form.filials"
            type="select"
            label="Филиал"
            placeholder="Все"
            :searchable="true"
            :multiple="true"
            :items="collections.filials"
          />
        </div>
        <div class="col col-12 col-md-5 col-xl-5">
          <c-input
            v-model="form.typePosts"
            type="select"
            label="Группа должности"
            placeholder="Все"
            :searchable="true"
            :multiple="true"
            :items="collections.typePosts"
          />
        </div>
      </div>
      
      <div class="function-information__posts">
        <h3 class="function-information__posts-title">Должности исполнителя</h3>
        <div class="function-information__posts-list">
          <draggable
            v-model="form.posts"
            group="group"
            :force-fallback="true"
            ghost-class="sortable__ghost"
            :disabled="form.posts.length < 2"
          >
            <div class="function-information__posts-item row" v-for="(post, j) in form.posts" :key="post.id">
              <div class="function-information__posts-item-column col col-12 col-md-4 col-xl-4">
                <c-input
                  v-model="post.code"
                  type="select"
                  label="Должность"
                  :searchable="true"
                  :placeholder="'Любая'"
                  :items="collections.posts"
                  :clearable="true"
                />
                <a v-if="post.code && post.code.value" :href="$router.resolve({ name: 'position-form', params: { positionCode: post.code.value } }).href" class="function-information__posts-item-settings" target="_blank">
                  Перейти к настройке должности
                </a>
              </div>
              <div class="function-information__posts-item-column col col-12 col-md-4 col-xl-4">
                <c-input
                  v-model="post.specialities"
                  type="select"
                  label="Специальность"
                  :multiple="true"
                  :searchable="true"
                  :placeholder="'Все'"
                  :items="post.code && post.code.collections ? post.code.collections.specialities : []"
                  :disabled="!post.code || (post.code.collections && !post.code.collections.specialities.length)"
                  :clearable="true"
                />
              </div>
              <div class="function-information__posts-item-column col col-12 col-md-2 col-xl-2">
                <c-input
                  v-model="post.categories"
                  type="select"
                  label="Разряд"
                  :multiple="true"
                  :searchable="true"
                  :placeholder="'Все'"
                  :items="post.code && post.code.collections ? post.code.collections.categories : []"
                  :disabled="!post.code || (post.code.collections && !post.code.collections.categories.length)"
                  :clearable="true"
                />
              </div>
              <div class="function-information__posts-item-actions">
                <c-button
                  v-if="form.posts.length > 1"
                  v-b-popover.hover.blur.top="'Удалить должность'"
                  class="function-information__posts-item-remove"
                  :icon="{ icon: 'trash', color: 'secondary' }"
                  size="iconic"
                  @click="deletePost(post.id)"
                />
                <c-button
                  v-if="form.posts.length > 1"
                  class="function-information__posts-item-move"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    boundary: 'window',
                    content: 'Переместить',
                    placement: 'top',
                  }"
                  size="iconic"
                  icon="arrows-constructor"
                />
              </div>
            </div>
          </draggable>
        </div>
        <c-button
          :responsive="true"
          size="small"
          label="Добавить должность"
          :icon="{ icon: 'plus', color: 'primary' }"
          @click="addPost"
          :disabled="addPostIsDisabled"
        />
      </div>

      <div class="function-information__performers" id="performers">
        <div class="function-information__performers-header">
          <h3 class="function-information__performers-title">Исполнители</h3>
          <div v-if="workersTotalCount" class="function-information__performers-counter">
            <span v-if="checkedPerformersListCounter">{{ checkedPerformersListCounter }} из</span> <span v-else>Всего</span> {{ workersTotalCount }}
          </div>
        </div>
        <div class="function-information__performers-list">
          <div v-for="performer in checkedPerformersList" class="function-information__performer" :key="performer.id">
            <img :src="`${performer.photo ? performer.photo : '/redesign/img/userpic.svg'}`" class="function-information__performer-photo" width="34" height="34" />
            <div class="function-information__performer-text">
              <div class="function-information__performer-name">{{ performer.fio }}</div>
              <div class="function-information__performer-filial">{{ performer.filial_name }}</div>
            </div>
            <button class="function-information__performer-delete" @click="uncheckPerformer(performer.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.325608 11.2266C-0.0649162 10.8361 -0.0649162 10.2029 0.325608 9.8124L9.36312 0.773484C9.75364 0.38296 10.3868 0.38296 10.7773 0.773484C11.1679 1.16401 11.1679 1.79717 10.7773 2.1877L1.73982 11.2266C1.3493 11.6171 0.716132 11.6171 0.325608 11.2266Z" fill="#FF238D"/>
                <path d="M10.6836 11.1641C11.0741 10.7736 11.0741 10.1404 10.6836 9.74992L1.70711 0.773484C1.31658 0.38296 0.683417 0.38296 0.292893 0.773484C-0.0976311 1.16401 -0.0976311 1.79717 0.292893 2.1877L9.26935 11.1641C9.65987 11.5547 10.293 11.5547 10.6836 11.1641Z" fill="#FF238D"/>
              </svg>
            </button>
          </div>
          <button @click="addCheckedPerformersVisibleCounter" v-if="addCheckedPerformersVisibleCounterIsVisible" class="function-information__performers-list-more">еще {{counterShowPerformers}} сотрудников</button>
          <button @click="checkedPerformersVisibleCounter = 9" v-if="collapseCheckedPerformersListIsVisible" class="function-information__performers-list-collapse">свернуть</button>
        </div>
        <c-button
          v-if="workersTotalCount"
          class="function-information__performers-list-change"
          :responsive="true"
          size="small"
          label="Изменить список исполнителей"
          :icon="{ icon: 'man' }"
          @click="openPerformersSidesheet"
        />
        <p v-else class="function-information__performers-no-items">Нет исполнителей с заданными параметрами</p>
      </div>

      <div class="function-information__settings">
        <h3 class="function-information__settings-title">Настройки</h3>
        <div class="row">
          <div class="col col-12 col-md-10 col-xl-10">
            <c-input
              v-model="form.responsible"
              type="select"
              floating-label="Ответственный"
              :searchable="true"
              :multiple="true"
              :items="collections.responsible"
            />
          </div>
        </div>
        <div class="row">
          <div class="col col-12 col-md-3 col-xl-2">
            <c-input
              type="integer-number"
              v-model="form.laborCosts"
              label="Трудозатраты, часов"
              placeholder="0"
              :max-length="3"
              :clearable="true"
            />
          </div>
          <div class="col col-5 col-md-2 col-xl-2">
            <c-input
              type="integer-number"
              v-model="form.repeatInterval"
              label="Частота выполнения"
              placeholder="0"
              :max-length="2"
              :clearable="true"
            />
          </div>
          <div class="col col-7 col-md-3 col-xl-2">
            <c-input
              v-model="form.repeatType"
              type="select"
              floating-label="Период"
              :items="collections.repeatTypes"
              :disabled="!form.repeatInterval"
              style="margin-top: -5px;"
            />
          </div>
        </div>
        <div class="row">
          <div class="col col-12 col-md-10 col-xl-10">
            <c-input
              v-model="form.tools"
              type="select"
              floating-label="Инструменты"
              :searchable="true"
              :multiple="true"
              :items="collections.tools"
            />
          </div>
        </div>
        <div class="row">
          <div class="col col-12 col-md-10 col-xl-10">
            <c-input
              ref="tasks"
              type="textarea"
              v-model="form.tasks"
              floating-label="Решаемые задачи"
              :clearable="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col col-12 col-md-10 col-xl-10">
            <c-input
              v-model="form.vep"
              :max-length="255"
              floating-label="ЦКП функции"
              :clearable="true"
            />
          </div>
        </div>
      </div> 

      <div class="function-information__description">
        <h3 class="function-information__description-title">Описание</h3>
        <div class="row">
          <div class="col col-12 col-md-10 col-xl-10">
            <c-input
              ref="comment"
              type="textarea"
              v-model="form.comment"
              floating-label="Комментарий"
              :clearable="true"
              max-length="255"
            />
          </div>
        </div>
        <div v-for="link in form.links" class="function-information__link row" :key="link.id">
          <div class="col col-11 col-md-10 col-xl-10">
            <c-input
              v-model="link.value"
              :max-length="255"
              floating-label="Ссылка"
              :clearable="true"
            />
          </div>
          <div class="col col-1 col-md-11 col-xl-1">
            <c-button
              v-if="form.links.length > 1"
              v-b-popover.hover.blur.top="'Удалить'"
              class="function-information__link-remove"
              :icon="{ icon: 'trash', color: 'secondary' }"
              size="iconic"
              @click="deleteLink(link.id)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col col-xl-12 col-md-12 col-12">
            <c-button
              :responsive="true"
              size="small"
              label="Добавить ссылку"
              :icon="{ icon: 'plus', color: 'primary' }"
              @click="addLink"
              :disabled="addLinkIsDisabled"
            />
          </div>
        </div>
        <div class="row">
          <div class="col col-xl-8 col-md-12 col-12">
            <file-loader
              ref="fileLoader"
              v-model="form.files"
              :links="form.fileLinks"
              format="images,pdf,docs,video"
              actions="loadFiles,preview"
              :limit="10"
              @changeLinks="form.fileLinks = $event"
            >
              <template #note>
                <div class="note">
                  Допустимые форматы: .jpeg, .jpg, .gif, .png, .mp4, .mov, .mpeg-1,2, .webm, .pdf, .docx. Размер файла — не более 10Мб.
                </div>
              </template>
            </file-loader>
          </div>
        </div>
      </div>

      <div class="function__actions function__actions--fixed">
        <c-button class="function__action" label="Отменить" size="large" @click="onReset" />
        <c-button class="function__action" label="Сохранить" size="large" color="primary" @click="onSubmit" :disabled="isSubmitDisabled" />
      </div>
    </div>
    <c-loader
      v-if="isLoading"
      label="Данные загружаются"
      :active="isLoading"
      height="400"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions";
import draggable from "vuedraggable";
import PerformersSidesheet from "./components/PerformersSidesheet";
import Loader from "@/components/loader";
import FileLoader from "@/components/file-loader";
import { getFileName, getFileType } from "@/utils/files";

export default {
  name: "function-information",

  components: {
    "c-button": CButton,
    "c-input": CInput,
    "c-loader": Loader,
    draggable,
    ResponsiveApplyResetActions,
    PerformersSidesheet,
    FileLoader,
  },

  async created() {
    this.isLoading = true;

    await this.$store.dispatch("personalEmployee/transactions/fetchFilialsList").then((res) => {
      this.collections.filials = [];

      this.collections.filials = res
        .sort((a, b) => b.sort - a.sort)
        .map((filial) => ({
          value: filial.id,
          label: filial.name,
        }))
    })

    await this.$store.dispatch("personalEmployee/getTypePostList").then((res) => {
      const typePosts = res.items

      this.collections.typePosts = typePosts.map(typePost => ({
        value: typePost.code,
        label: typePost.name
      }))
    })

    await this.$store.dispatch("functions/getResponsibleList").then((res) => {
      this.collections.responsible = res.map(item => ({
        value: item.id,
        label: item.name
      }))
    })

    await this.$store.dispatch("functions/getRepeatTypes").then((res) => {
      this.collections.repeatTypes = res.map(item => ({
        value: item.code,
        label: "В " + item.name
      }))

      this.form.repeatType = this.collections.repeatTypes[0]
    })

    await this.$store.dispatch("functions/getToolsList").then((res) => {
      this.collections.tools = res.map(item => ({
        value: item.id,
        label: item.name
      }))
    })
    
    await this.$store.dispatch("educationalMaterials/getPositions", {custom: true}).then((res) => {
      this.formatPosts(res)
    })

    await this.setDataFromFunctionModel();
    await this.updateWorkersList(null, true);

    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },

  data() {
    return {
      isLoading: false,
      isLoadingPerfomers: false,
      isSubmitted: false,
      pending: false,
      postsIdsCounter: 0,
      performersPage: 1,
      checkedPerformersVisibleCounter: 9,
      linksIdsCounter: 0,
      inited: false,

      model: {},

      form: {
        name: "",
        filials: [],
        typePosts: [],
        posts: [],
        workers: [],
        responsible: [],
        laborCosts: "",
        repeatInterval: "",
        repeatType: "",
        tools: [],
        tasks: "",
        vep: "",
        comment: "",
        links: [],
        files: [],
        fileLinks: [],
      },

      oldPosts: [],

      collections: {
        filials: [],
        typePosts: [],
        posts: [],
        workers: [],
        responsible: [],
        repeatTypes: [],
        tools: []
      },

      defaultPost: {
        code: "",
        specialities: [],
        categories: [],
      },
    }
  },
  
  computed: {
    ...mapState({
      workers: (state) => state.functions.workers,
      workersTotalCount: (state) => state.functions.workersTotalCount,
      workersPageCount: (state) => state.functions.workersPageCount,
      functionModel: (state) => state.functions.functionModel,
      defaultPerformers: (state) => state.functions.defaultPerformers,
    }),

    isSubmitDisabled() {
      return this.pending;
    },
    nameError() {
      return !this.form.name && "Обязательное поле"
    },
    addPostIsDisabled() {
      let disabled = false;

      if (this.form.posts.length) {
        disabled = true;

        if (this.form.posts[this.form.posts.length -1].code) disabled = false
      }

      return disabled
    },
    addLinkIsDisabled() {
      let disabled = false;

      if (this.form.links.length) {
        disabled = true;

        if (this.form.links[this.form.links.length -1].value) disabled = false
      }

      return disabled
    },

    checkedNoFilteredPerformesList() {
      let array = [];
      //console.log(this.collections.workers.length, this.workers.length)
      if (this.collections.workers.filter(worker => !worker.checked).length) {
        array = [...this.collections.workers.filter(worker => worker.checked)];
        //console.log(array.length, this.defaultPerformers.length)
        if (this.defaultPerformers && this.defaultPerformers.length) {
          this.defaultPerformers.forEach(worker => {
            let findedWorker = this.collections.workers.find(workerInList => workerInList.id === worker.id);
            if (!findedWorker) {
              //array.push({...worker, fio: worker.name})
            }
          })
        }
      }
      console.log(array.length)
      return array
    },

    checkedPerformersList() {
      if (this.workers.find(performer => !performer.checked)) {
        return this.checkedNoFilteredPerformesList.filter((worker, i) => i < this.checkedPerformersVisibleCounter)
      }
    },
    checkedPerformersListCounter() {
      if (this.workers.find(performer => !performer.checked)) return this.checkedNoFilteredPerformesList.length
    },
    counterShowPerformers(){
      const c = this.checkedNoFilteredPerformesList.length - this.checkedPerformersVisibleCounter;
      return c > 9 ? 9 : c;
    },
    addCheckedPerformersVisibleCounterIsVisible() {
      return this.checkedPerformersList && this.checkedNoFilteredPerformesList.length > 9 && this.checkedPerformersVisibleCounter <= this.checkedNoFilteredPerformesList.length
    },
    collapseCheckedPerformersListIsVisible() {
      return this.checkedPerformersList && this.checkedNoFilteredPerformesList.length > 9 && this.checkedPerformersVisibleCounter >= this.checkedNoFilteredPerformesList.length
    }
  },

  watch: {
    functionModel: {
      handler() {
        this.setDataFromFunctionModel();
      },  
      deep: true
    },
    isLoading: {
      handler(e) {
        if (!e) {
          // наполняем форму именно после завершения загрузки
          this.setDataFromFunctionModel();
        }
      },
    },
    "form.filials": {
      handler() {
        console.log("change filials");
        if ((this.$route.query.id && this.inited) || !this.$route.query.id) {
          this.form.workers = [];
          this.updateWorkersList();
        }
      },
      deep: true
    },
    "form.posts": {
      handler() {
        this.form.posts.forEach(post => {
          let findedOldValue = this.oldPosts.find(oldPost => oldPost.id === post.id);
          if (findedOldValue) {
            if (JSON.stringify(post.code) !== JSON.stringify(findedOldValue.code)) {
              post.categories = [];
              post.specialities = [];
            }
          }
        })

        this.oldPosts = JSON.parse(JSON.stringify(this.form.posts));

        this.collections.posts.forEach(post => {
          let findedPost = this.form.posts ? this.form.posts.find(postInForm =>  postInForm.code && postInForm.code.value === post.value) : null;

          if (findedPost) {
            post.disabled = true;
          } else {
            post.disabled = false;
          }
        })

        if ((this.$route.query.id && this.inited) || !this.$route.query.id) {
          // Workers
          this.form.workers = [];
          this.updateWorkersList();
        }
      },
      deep: true
    },
    "form.typePosts": {
      async handler() {
        // Posts
        this.form.posts = [];

        let typePosts = this.form.typePosts.map(typePost => (typePost.value)).join(',')

        await this.$store.dispatch("educationalMaterials/getPositions", {typePost: typePosts, custom: true}).then((res) => {
          this.formatPosts(res)
        })

        if ((this.$route.query.id && this.inited) || !this.$route.query.id) {
          // Workers
          this.form.workers = [];
          this.updateWorkersList();
        }
      },
      deep: true
    },
  },

  methods: {
    validate() {
      return !this.nameError
    },
    getParams() {
      let params = {
        page: "information",
        name: this.form.name,
        filials: this.form.filials,
        typePosts: this.form.typePosts,
        posts: this.form.posts,
        workers: this.checkedNoFilteredPerformesList.length ? this.checkedNoFilteredPerformesList : [],
        responsible: this.form.responsible,
        laborCosts: this.form.laborCosts,
        repeatInterval: this.form.repeatInterval,
        repeatType: this.form.repeatInterval ? this.form.repeatType : "",
        tools: this.form.tools,
        tasks: this.form.tasks,
        vep: this.form.vep,
        comment: this.form.comment,
        links: this.form.links,
        files: this.form.files,
      }

      if (this.functionModel.id) params.id = this.functionModel.id
      if (this.functionModel.files && this.functionModel.files.length) params.oldFiles = this.functionModel.files.map(({ id }) => id)

      return params
    },
    async onSubmit() {
      this.isSubmitted = true;

      if (!this.validate()) {
        return;
      }

      let params = this.getParams();

      this.pending = true;

      if (!this.functionModel.id) {
        await this.$store.dispatch("functions/createFunction", params)
          .then(res => {
            this.$router.replace({ name: "function-information", query: {id: this.functionModel.id} });
          })
          .finally(res => {
            this.pending = false;
          })
      } else {
        await this.$store.dispatch("functions/updateFunction", params)
          .finally(res => {
            this.pending = false;
          })
      }
    },
    onReset() {
      this.setDataFromFunctionModel();
    },
    addPost() {
      this.form.posts.push({id: this.postsIdsCounter, ...this.defaultPost})
      this.postsIdsCounter++
    },
    deletePost(postId) {
      this.form.posts = this.form.posts.filter(post => post.id !== postId);
    },
    addLink() {
      this.form.links.push({id: this.linksIdsCounter, value: ""})
      this.linksIdsCounter++
    },
    deleteLink(linkId) {
      this.form.links = this.form.links.filter(link => link.id !== linkId);
    },
    formatPosts(posts) {
      this.collections.posts = [];

      Object.entries(posts).forEach(([key, value]) => {
        let categories = [];
        let specialities = [];

        Object.entries(value.categories).forEach(([key2, value2]) => {
          categories.push({value: key2, label: value2})
        })

        Object.entries(value.specialties).forEach(([key3, value3]) => {
          specialities.push({value: key3, label: value3})
        })

        this.collections.posts.push({
          value: key,
          label: value.name,
          sort: value.sort,
          collections: {
            categories: categories,
            specialities: specialities,
          }
        })

        this.collections.posts = this.collections.posts.sort((a, b) => b.sort - a.sort)
      });
    },
    openPerformersSidesheet() {
      this.$refs.performersSidesheet.open()
    },
    updateWorkersList(search, reset) {
      let checked = this.collections.workers.filter((w) => w.checked).map((w)=>w.id);

      let params = {
        filials: this.form.filials.map(filial => (filial.value)),
        typePosts: this.form.typePosts.map(typePost => (typePost.value)),
        posts: this.form.posts.map(post => {
          if (post.code && post.code.value) return ({
          code: post.code.value,
          specialities: post.specialities.map(speciality => (speciality.value)),
          categories: post.categories.map(category => (category.value))
        })}),
        search
      }

      this.$store.dispatch("functions/getWorkersList", params).then(res => {
        this.collections.workers = res.map((w) => {
          w.checked = checked.indexOf(w.id)>=0;
          return w;
        })
        //this.workers = this.collections.workers;
        if (reset) {
          this.resetWorkers()
        }
      })
    },
    updateWorkersListWithFilters(search, reset) {
      this.performersPage = 1;
      this.updateWorkersList(search, reset);
    },
    async goToNextPagePerformers(search) {
      if (this.isLoadingPerfomers) {
        return
      }

      if (this.performersPage < this.workersPageCount) {
        this.isLoadingPerfomers = true;
        this.performersPage++;
        await this.updateWorkersList(search);
        console.log('5')
        setTimeout(() => {
          this.isLoadingPerfomers = false;
        }, 500);
      }
    },
    uncheckPerformer(id) {
      let findedPerformer = this.workers.find(performer => performer.id === id)

      if (findedPerformer) {
        findedPerformer.checked = false;
      } else {
        this.$store.commit("functions/setDefaultPerformers", this.defaultPerformers.filter(performer => performer.id !== id))
      }
    },
    addCheckedPerformersVisibleCounter() {
      this.checkedPerformersVisibleCounter += 9
    },
    setDataFromFunctionModel() {
      if (!this.functionModel.id) {
        return
      }
      this.inited = false;
      this.form.name = this.functionModel.name
      this.form.filials = [];

      if (this.functionModel.filials && this.functionModel.filials.length) {
        this.functionModel.filials.forEach(filial => {
          let findedFilial = this.collections.filials.find(filialInCollection => Number(filialInCollection.value) === Number(filial.id));
          if (findedFilial) this.form.filials.push(findedFilial)
        })
      }

      this.form.typePosts = [];
      if (this.functionModel.executives && this.functionModel.executives.typePosts && this.functionModel.executives.typePosts.length) {
        this.functionModel.executives.typePosts.forEach(typePost => {
          let findedTypePost = this.collections.typePosts.find(typePostInCollection => String(typePostInCollection.value) === String(typePost.code));
          if (findedTypePost) this.form.typePosts.push(findedTypePost)
        })
      }


      //setTimeout(() => {
        this.form.posts = [];

        if (this.functionModel.executives && this.functionModel.executives.posts && this.functionModel.executives.posts.length) {
          this.functionModel.executives.posts.forEach(post => {
            let findedPost = this.collections.posts.find(postInCollection => String(postInCollection.value) === String(post.post.code))


            if (findedPost) {
              let categories = [];
              if (post.ranks.length) {
                post.ranks.forEach(rank => {
                  categories.push(findedPost.collections.categories.find(category => String(category.value) === String(rank.id)))
                })
              }

              let specialities = [];
              if (post.specialities.length) {
                post.specialities.forEach(speciality => {
                  specialities.push(findedPost.collections.specialities.find(specialityInCollection => String(specialityInCollection.value) === String(speciality.id)))
                })
              }

              this.form.posts.push({id: this.postsIdsCounter, ...this.defaultPost, code: {...findedPost}, categories, specialities})
              this.postsIdsCounter++
       //       this.updateWorkersListWithFilters(null, true)
              //console.log("!!!", findedPost, this.functionModel.executives.posts, this.collections.posts, this.form.posts.length)
            }
          })
        }
     //}, 10);

      //this.resetWorkers();

      this.form.responsible = [];

      if (this.functionModel.responsible && this.functionModel.responsible.length) {
        this.functionModel.responsible.forEach(responsibleItem => {
          let findedResponsibleItem = this.collections.responsible.find(responsibleItemInCollection => String(responsibleItemInCollection.value) === String(responsibleItem.id));
          if (findedResponsibleItem) this.form.responsible.push(findedResponsibleItem)
        })
      }

      this.form.laborCosts = this.functionModel.labor_costs;
      this.form.repeatInterval = this.functionModel.repeat_interval;
      if (this.form.repeatInterval) {
        this.form.repeatType = this.collections.repeatTypes.find(repeatType => repeatType.value === this.functionModel.repeat_type)
      }

      this.form.tools = [];

      if (this.functionModel.tools && this.functionModel.tools.length) {
        this.functionModel.tools.forEach(tool => {
          let findedTool = this.collections.tools.find(toolInCollection => Number(toolInCollection.value) === Number(tool.id));
          if (findedTool) this.form.tools.push(findedTool)
        })
      }

      this.form.tasks = this.functionModel.tasks
      setTimeout(() => {
        if (this.$refs.tasks) {
          this.$refs.tasks.setValue(this.functionModel.tasks)
          this.$refs.tasks.textValue = this.functionModel.tasks
          this.$refs.tasks.$refs.textareaValue.innerHTML = this.functionModel.tasks
        }
      }, 1000);

      this.form.vep = this.functionModel.vep

      this.form.comment = this.functionModel.comment
      setTimeout(() => {
        if (this.$refs.comment) {
          this.$refs.comment.setValue(this.functionModel.comment)
          this.$refs.comment.textValue = this.functionModel.comment
          this.$refs.comment.$refs.textareaValue.innerHTML = this.functionModel.comment
        }
      }, 1000);

      this.form.links = [];

      if (this.functionModel.links && this.functionModel.links.length) {
        this.functionModel.links.forEach(link => {
          this.form.links.push({id: this.linksIdsCounter, value: link})
          this.linksIdsCounter++
        })
      }

      this.form.fileLinks = [];
      this.form.files = [];

      if (this.$refs.fileLoader) {
        this.$refs.fileLoader.clear();
      }

      if (this.functionModel.files && this.functionModel.files.length) {
        this.form.fileLinks = this.functionModel.files.map(({ id, name }) => ({
          id,
          name: getFileName(name),
          type: getFileType(name),
          url: name,
        }));
      }

      setTimeout(() => {
        this.inited = true;
      }, 5000);
    },

    resetWorkers() {
      console.log("reset", this.workers.length)
//      setTimeout(() => {
        if (this.functionModel.executives && this.functionModel.executives.workers && this.functionModel.executives.workers.length) {
          this.workers.forEach(worker => {
            let findedWorker = this.functionModel.executives.workers.find(workerInModel => Number(workerInModel.id) === Number(worker.id))
            if (findedWorker) {
              console.log("find");
              worker.checked = true
            } else {
              worker.checked = false
            }
          })
        } else {
          this.workers.forEach(worker => {
            worker.checked = true
          })
        }
  //    }, 500);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.function-information {
  padding-top: 36px;

  .row {
    margin-bottom: 30px;
  }

  .note {
    font-size: 11px;
    display: flex;
    align-items: center;
    min-height: 30px;
    color: $color-label;
    max-width: 600px;
    margin-left: 30px;
  }

  &__posts {
    margin-top: 40px;

    &-title {
      font-size: 18px;
      font-weight: 500;
      margin: 0 0 25px;
    }

    &-item {
      margin: -20px -15px 0;
      padding: 20px 0;

      &-actions {
        display: flex;
        align-items: center;
      }
      &-move {
        transform: translate(10px, 3px);
      }
      &-settings {
        font-size: 13px;
        font-weight: 500;
        line-height: 100%;
        margin-top: 10px;
      }
    }
  }

  &__performers {
    margin-top: 40px;

    &-no-items {
      color: #8E9CBB;
    }

    &-header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    &-title {
      font-size: 18px;
      font-weight: 500;
      line-height: normal;
      margin: 0;
    }
    &-counter {
      color: #8E9CBB;
      font-size: 15px;
      font-weight: 400;
      line-height: 150%;
      margin-left: 5px;
    }
    &-list {
      margin: -4px;
      display: flex;
      flex-wrap: wrap;

      &-more,
      &-collapse {
        color: var(--turn-on, #06F);
        font-size: 13px;
        line-height: 110%;
        background: unset;
        border: unset;
      }
      &-change {
        margin-top: 10px;
      }
    }
  }

  &__performer {
    border-radius: 50px;
    border: 1px solid #D3D8DF;
    padding: 2px 15px 2px 2px;
    display: flex;
    align-items: center;
    width: fit-content;
    margin: 4px;

    &-photo {
      border-radius: 34px;
    }
    &-text {
      margin: 0 10px;
    }
    &-name {
      font-size: 12px;
      font-weight: 500;
      line-height: 110%;
    }
    &-filial {
      color: var(--unnamed, #8E9CBB);
      font-feature-settings: 'clig' off, 'liga' off;
      font-size: 11px;
      line-height: 110%;
    }
    &-delete {
      background: unset;
      border: unset;
    }
  }

  &__settings {
    margin-top: 40px;

    &-title {
      font-size: 18px;
      font-weight: 500;
      margin: 0 0 25px;
    }
  }

  &__description {
    margin-top: 40px;

    &-title {
      font-size: 18px;
      font-weight: 500;
      margin: 0 0 25px;
    }
  }

  &__link {
    align-items: center;
  }
}
</style>